/**
 * ÂMEDORÉE — Quick view ("Select size" from the cart, a collection or Complete the look)
 *
 * No size is selected when the quick view opens (same as the product page). The button
 * reads "Select size" and points at the sizes until one is picked. Picking a size makes
 * the theme re-render the quick view; that new HTML is still rendered without a selection,
 * so it is switched to the picked size and the real button label before the theme uses it.
 *
 * Liquid side: snippets/buy-buttons.liquid (data-amd-needs-size, data-amd-label) and
 * snippets/option-value.liquid (data-amd-was-selected).
 *
 * The re-render is fetched without the collection, so the fit line keeps the one shown
 * when the quick view opened (men's or women's).
 *
 * After "Add to cart" the quick view closes, so the cart with the new piece is in view.
 */
(function () {
  'use strict';

  if (window.AmedoreeQuickView) return;

  var GATE = 'buy-buttons[data-amd-needs-size]';

  function shake(from) {
    var root = (from.closest && from.closest('.amd-qv')) || document;
    var values = root.querySelector('.variant-picker__option-values--amd-size') || root.querySelector('variant-picker .variant-picker__option-values');
    var option = values && values.closest('.variant-picker__option');
    if (!option) return;

    option.classList.remove('amd-needs-size');
    void option.offsetWidth;
    option.classList.add('amd-needs-size');
  }

  function setLabel(buyButtons) {
    var label = buyButtons.getAttribute('data-amd-label');
    buyButtons.removeAttribute('data-amd-needs-size');
    if (!label) return;

    buyButtons.querySelectorAll('button[type="submit"] .button__content').forEach(function (content) {
      content.textContent = label;
      if (content.hasAttribute('rotated-text')) content.setAttribute('rotated-text', label);
      if (content.hasAttribute('up-text')) content.setAttribute('up-text', label);
    });
  }

  // The button asks for a size instead of adding the first one
  document.addEventListener(
    'click',
    function (event) {
      var button = event.target.closest && event.target.closest('button[type="submit"]');
      if (!button || !button.closest(GATE)) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      shake(button);
    },
    true
  );

  document.addEventListener(
    'submit',
    function (event) {
      if (!event.target.querySelector || !event.target.querySelector(GATE)) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      shake(event.target);
    },
    true
  );

  // A size was picked: show it selected, with the real button label
  document.addEventListener(
    'product:rerender',
    function (event) {
      var fragment = event.detail && event.detail.htmlFragment;
      if (!fragment || !fragment.querySelectorAll) return;

      var roots = [fragment];
      fragment.querySelectorAll('template').forEach(function (template) {
        roots.push(template.content);
      });

      // The re-render is fetched without the collection, so it would show the men's fit line
      var liveFit = document.querySelector('#quick-buy-modal-content .amd-fit-note');

      roots.forEach(function (root) {
        root.querySelectorAll('#quick-buy-modal-content').forEach(function (view) {
          var nextFit = view.querySelector('.amd-fit-note');
          if (liveFit && nextFit) nextFit.textContent = liveFit.textContent;

          view.querySelectorAll('input[data-amd-was-selected]').forEach(function (input) {
            input.removeAttribute('data-amd-was-selected');
            input.setAttribute('checked', 'checked');
            input.checked = true;
          });
          view.querySelectorAll(GATE).forEach(setLabel);
        });
      });
    },
    true
  );

  // Added: close the quick view so the cart (now with the piece) is what they see
  document.addEventListener('variant:add', function (event) {
    var modal = event.target && event.target.closest && event.target.closest('quick-buy-modal');
    if (modal && modal.querySelector('.amd-qv') && typeof modal.hide === 'function') modal.hide();
  });

  window.AmedoreeQuickView = { shake: shake };
})();
